import {Directive, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[def-title-select]'
})
export class DefTitleSelect {

    @Input() lblId: string;

    constructor() { }

    @HostListener('click') onClick() {
        let idLabel = this.lblId;
        setTimeout(function (idLbl) {
            if(idLbl) {
                let title = document.getElementById(idLbl).innerHTML;
                let d1 = document.getElementsByClassName('alert-head');
                d1[0].innerHTML = '<h2 class="alert-title" id="alert-hdr-0">'+title+'</h2>';
            }
        }, 100, idLabel);
    }

}



// WEBPACK FOOTER //
// ./src/directives/def-title-select/def-title-select.ts